import React, { useState } from 'react';
import { Box, Typography, MenuItem, Select, FormControl, Button,TextField } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import { Person } from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";



export default function FirstLogin() {
    const [formData, setFormData] = useState({
        email: "",
        telephone: "",
        adresse: "",
        motDePasse: "",
        confirmation: "",
      });
    
      const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };
    
      const inputStyle = {
        '& .MuiOutlinedInput-root': {
          height: 35,
          '&:hover fieldset': { borderColor: '#000' },
          '&.Mui-focused fieldset': { borderColor: 'red' }
        }
      };
  return (
    <>
      <Navbar />
      <Box p={3}>
      <Box sx={{ borderLeft:'2px solid',borderColor:"red", p: 2, borderRadius: 3, mb: 1  }}>
                <Typography variant="subtitle1">
                Veuillez compléter vos informations
                </Typography>
          </Box>  
      <Box display="flex" alignItems="center">
            <Person />
            <Typography variant="h6" ml={1}> MODIFIER MES INFORMATIONS </Typography>
          </Box> 
        <Box display="flex" mt={1}>
          
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
        <Typography variant="subtitle2">Email</Typography>
        <TextField fullWidth type="email" name="email" value={formData.email} onChange={handleChange} variant="outlined" sx={inputStyle} />   

        <Typography variant="subtitle2">Téléphone</Typography>
        <TextField fullWidth type="text" name="telephone" value={formData.telephone} onChange={handleChange} variant="outlined" sx={inputStyle} />

        <Typography variant="subtitle2">Adresse</Typography>
        <TextField fullWidth type="text" name="adresse" value={formData.adresse} onChange={handleChange} variant="outlined" sx={inputStyle} />

      
        <Typography variant="subtitle2">Email</Typography>
        <TextField fullWidth type="email" name="email" value={formData.email} onChange={handleChange} variant="outlined" sx={inputStyle} />

        <Typography variant="subtitle2">Mot de passe</Typography>
        <TextField fullWidth type="password" name="motDePasse" value={formData.motDePasse} onChange={handleChange} variant="outlined" sx={inputStyle} />

        <Typography variant="subtitle2">Confirmation</Typography>
        <TextField fullWidth type="password" name="confirmation" value={formData.confirmation} onChange={handleChange} variant="outlined" sx={inputStyle} />
        <Typography variant="subtitle2">Merci de sélectionner les cordonnées GPS de votre domicile sur la carte, afin de les utiliser comme base lors de la planification votre transport.</Typography>
           <Box>
                    <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.7562802733644!2d100.54655041550001!3d13.724893801085902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f3d8f9f2db5%3A0x6f2ef9a4895671c5!2sGoogle%20Thailand%20Office!5e0!3m2!1sen!2sth!4v1617154202027!5m2!1sen!2sth"
                    width="100%"
                    height="500"
                    style={{ borderRadius: '4px' }}
                   />
                </Box>
        
      </Box>
      
        </Box>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button variant="outlined" sx={{ color: "red", borderColor: "red", textTransform: "none", "&:hover": { backgroundColor: "red", color: "#fff", borderColor: "red" } }} startIcon={<CloseIcon />} >
          Annuler
        </Button>
        <Button variant="outlined" sx={{ color: "red", borderColor: "red", textTransform: "none", "&:hover": { backgroundColor: "red", color: "#fff", borderColor: "red" } }} startIcon={<CheckIcon />}>
          Save
        </Button>
      </Box>
      </Box>
    </>
  );
}
